import React, { useEffect, useContext, useState } from "react";

import SubHeaderComponent from '../sub-header/hoa-sub-header';

import './hoa-dashboard-style.scss';

import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Badge from "@mui/material/Badge";
import { Stack, LinearProgress, Button, Modal, Container  } from "@mui/material";
import SaveIcon from '@mui/icons-material/Save';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

import datastore from '../../store/hoa-datastore';
import { GlobalContext } from '../../context/hoa-global-context';

import HoaViewMainDashboard from './view/vertical-component/hoa-view-component';
import HoaUpdateMainDashboard from './update/hoa-update-main-comp';
import HoaBasicForm from './hoa-forms/hoa-basic-form';
import HoaSelectMunicipalityForm from './hoa-forms/hoa-select-municipality-form';

import dashboardServices from '../../services/hoa-dashboard-api-service';
import config from '../../hoa-config';

import DeleteContainerModal from '../delete-modal/hoa-delete-modal';
import BillableItemsModal from "../billableItems-modal/billable-items-modal";
import { compareAmenityObject, compareHoaBasicInfo, compareProcedure, deepCompare, deepCompareFields, deepCompareFieldsWithPaths, isMunicipalityChange, prepareBasicInforObject, isClientInfoChanged } from "../../utility/compare-item";
import { getOnboardingChangeEvents, saveNewLogsInDatastore } from "../../utility/change-log";
import { isEmailValid, isValidHttpUrl, isPhoneValid } from "../../utility/input-field-validation";
import { getFieldNamesWithInvisibleFields, getPropertyNamesWithInvisibleFields, shouldApplyEffectiveDate } from "../../utility/helper"
import TryagainModal from "../Tryagain-modal/TryagainModal";
import HoaOnboardingForm from "../hoa-onboarding/hoa-onboarding-form";
import HoaOnboardingView from "../hoa-onboarding/hoa-onboarding-view";
import LoadingComponent from "../loading-component/loading-component";
import useCreateLogs from '../../hooks/useCreateLogs';
import { compareObjects } from '../../utility/helper';
import EditCancelConfirmationModal from "../../shared-components/edit-cancel-confirmation";

const initialDocuments = {
    "CCNR Document": {},
    "By-laws Document": {},
    "Rules and Restrictions": {},
    "Articles of Incorporation": {},
    "HOA Tenant or Lease Registration/Renewal Form": {},
    "Other Documents": {},
    "Guidelines & Policies": {},
    "Plat Maps": {},
    "HOA Updates & Announcements": {},
    "HOA Forms": {}
}

const initialHoaOnboardingDataState = {
    isCompleted: false,
    completedBy: "",
    completedAt: "",
    data: {}
}

const initialHoaOnboardingData:any = {
    "clientDirectory": initialHoaOnboardingDataState,
    "portalSearch": initialHoaOnboardingDataState,
    "emailHoa": initialHoaOnboardingDataState,
    "callHoa": initialHoaOnboardingDataState
};

const initialOnboardingDocumentStateData:any = {
    "clientDirectory": [],
    "portalSearch": [],

    "emailHoa": [],
    "emailHoaScreenshot": [],
    
    "callHoa": [],
    "callHoaScreenshot": [],
}

type TabNames = keyof typeof tabNames;
const tabNames = {
    "Overview":"overViewRescrictedFields",
    "Procedures":"proceduresRescrictedFields",
    "Amenities":"newAmenitiesRescrictedFields",
    "Violation Regulation":"violationRescrictedFields",
    "Documents":"documentsRescrictedFields"
} as any;

export default function AddViewUpdateComponent(props: any) {
    const basicFormStateList : any = {
        name: '',
        market: '',
        city: '',
        coordinates: '',
        address: '',
        phone: '',
        email: '',
        fees: '',
        zip: '',
        paymentFrequency: '',
        hoaFeesPaymentDeadline: '',
        hoaPaymentInformation: '',
        boardMeetingSchedule: '',
        isGateAccessRequired : false,
        isPortalAccessRequired: false,
        residentGateAccessRequirement : '',
        guestAccessPermission: '',
        hoaPortalLink : '',
        pmcPortalLink: '',
        gateAccessFormFiles: [],
        residentLoginAvailable : false,
        masterHoaId: '',
        municipality: null,
        newAvailableAmenities:[],
        amenityEvents:[],
        accessInformation:[],
        violationRegulations: {},
        propertyManagementCompanyAvailable:false,
        propertyManager:{
            propertyManagerName:'',
            propertyManagerCompanyAddress:'',
            propertyManagerPhone:'',
            propertyManagerEmail:'',
        },
        isCommunityServiceEnabled:false,
        selectedCommunityService:'',
        communityServices:[],
        clientVendorId: '',
        procedures:{},
        hoaClientInfo: [],
        hoaEvents: []
    }
    interface FieldConfig {
        isVisible: boolean;
        fieldName: string[];
      }
      
      interface NestedFieldConfig {
        [key: string]: FieldConfig | NestedFieldConfig;
      }
      
      interface Config {
        [key: string]: NestedFieldConfig;
      }

    const violatioRegulationObj:any = {
        additionalInfoOfEmail: "",
        additionalInfoOfOther: "",
        additionalInfoOfPortal: "",
        assessmentFee: "",
        assessmentFrequency: "",
        assessmentViolationFee: "",
        assessmentViolationFeeAdditionalInfo: "",
        curePeriod: "",
        gracePeriod: "",
        graceTimeline: "",
        landscaping: {},
        maxViolationFees: "",
        minViolationFees: "",
        notificationType: "",
        nuisance: {},
        others: "",
        parking: {},
        preferredViolationRemediation: [],
        structure: {},
        timeline: "",
        trash: {},
        violationPayment: ""
    };

    const hoaTabTitles = config.hoaTabTitles;
    const { view, setView, setSuccess, previousHoa, setReloadFutureEffectiveDateLog } = props;
    const [loading, setLoading] = useState(false);
    const [isCancelClicked, setIsCancelClicked] = useState(false);
    const [currentHoa, setCurrentHoa] = useState<any>({});
    const [newAvailableAmenities,setNewAvailableAmenities]=useState([])
    const [amenityEvents,setAmenityEvents]=useState([])
    const [hoaEvents, setHoaEvents] = useState([])
    const [accessInformation,setAccessInformation]=useState([])
    const [violationRegulations, setViolationRegulations] = useState<any>({});
    const [checkError, setCheckError] = useState(false);
    const [error, setError] = useState(false);
    const [emailValid, setEmailValid] = useState(true);
    const [phoneValid, setPhoneValid] = useState(true);
    const [structureBuildingFiles, setStructureBuildingFiles] = useState({
        structureChangeFiles : [],
        architecturalFiles: []
    })
    const [sourceDocuments,setSourceDocuments] = useState([]);
    const [newAmenitiesWarning, setNewAmenitiesWarning] = useState(false);
    const [violationWarning, setViolationWarning] = useState(false);
    const [documentWarning, setDocumentWarning] = useState(false);
    const [procedureWarning, setProcedureWarning] = useState(false);
    const temp : any = {};
    const [selectedMunicipality, setSelectedMunicipality] = useState(temp);
    const [isDeleteModal, setIsDeleteModal] = useState(false)
    const [basicFormState, setBasicFormState] = useState(basicFormStateList);
    const [selectedBillItem, setSelectedBillItem] = useState(null);
    const [linkedEntryId, setLinkedEntryId] = useState(null);
    const [evidenceLink, setEvidenceLink] = useState(null);
    const [isBillableItemsModal, setIsBillableItemsModal] = useState(false);
    const [saveModalOpen, setSaveModalOpen] = useState(false);
    const [masterHoas, setMasterHoas] = useState<any>([]);
    const [currentMasterHoa, setCurrentMasterHoa] = useState(null);
    const [isDisabled, setIsDisabled] = useState(true);
    const [sourceId, setSourceId] = useState('');
    const [isVerified, setIsVerified] = useState(null);
    const [sourceDocumentType, setSourceDocumentType] = useState('');
    const [effectiveDate, setEffectiveDate] = useState(null);
    const [documentType, setDocumentType] = useState('');
    const [showApiErrorModal,setShowApiErrorModal] = useState(false)
    const [previousOnboardingDataState, setPreviousOnboardingDataState] = useState(JSON.parse(JSON.stringify(initialHoaOnboardingData)));
    const [onboardingDataState, setOnboardingDataState] = useState(JSON.parse(JSON.stringify(initialHoaOnboardingData)));
    const [previousOnboardingDocuments, setPreviousOnboardingDocuments] = useState(JSON.parse(JSON.stringify(initialOnboardingDocumentStateData)));
    const [onboardingDocuments, setOnboardingDocuments] = useState(JSON.parse(JSON.stringify(initialOnboardingDocumentStateData)));
    const [isOnboardingCompleted, setIsOnboardingCompleted] = useState(false);
    const [isClientDirectoryCompleted, setIsClientDirectoryCompleted] = useState(false);
    const [isClientDirectoryJustCompleted, setIsClientDirectoryJustCompleted] = useState(false);
    const [isOtherBillableItemsDisabled, setIsOtherBillableItemsDisabled] = useState(false);
    const [restrictedFields,setRestrictedFields]=useState<any>({
		overViewRescrictedFields:[],
		proceduresRescrictedFields:[],
		amenitiesRescrictedFields:[],
		newAmenitiesRescrictedFields:[],
		violationRescrictedFields:[],
		documentsRescrictedFields:[],
	})
    const [documentId, setDocumentId] = useState("")
    const [isDocumentIdVerified, setIsDocumentIdVerified] = useState(false)

    const {violationStructureBuildingFiles, updateViolationStructureBuildingFiles, amenitiesDocImage, updateAmenitiesDocImage, hoaDocumentToBeDeleted, updateHoaDocumentToBeDeleted, selectedHoaDocuments, updateSelectedHoaDocuments, selectedValues, hoa, updateHoaData, updateView, updateSelectedValues, activeTab, updateActiveTab, changeActiveMenu, activeMenu, property, updatePropertyData,selectedDataFieldConfigurator } = useContext<any>(GlobalContext);

    const { revertAddClientLog } = useCreateLogs();

    useEffect(()=>{
        if(selectedValues && selectedValues.violationRegulations){
            setViolationRegulations(selectedValues.violationRegulations);
        }
        if(selectedValues && selectedValues.newAvailableAmenities){
            setNewAvailableAmenities(selectedValues.newAvailableAmenities);
        }
        if(selectedValues && selectedValues.amenityEvents){
            setAmenityEvents(selectedValues.amenityEvents);
        }
        if(selectedValues && selectedValues.accessInformation){
            setAccessInformation(selectedValues.accessInformation);
        }
        if(selectedValues && selectedValues.hoaEvents){
            setHoaEvents(selectedValues.hoaEvents || []);
        }
        if(selectedValues && selectedValues.onboardingData) {
            setPreviousOnboardingDataState(JSON.parse(JSON.stringify(selectedValues.onboardingData)));
            setOnboardingDataState(JSON.parse(JSON.stringify(selectedValues.onboardingData)));
            populateOnboardingDocuments(JSON.parse(JSON.stringify(selectedValues.onboardingData)));
        }
        else {
            setPreviousOnboardingDataState(JSON.parse(JSON.stringify(initialHoaOnboardingData)));
            setOnboardingDataState(JSON.parse(JSON.stringify(initialHoaOnboardingData)));
            populateOnboardingDocuments(JSON.parse(JSON.stringify(initialHoaOnboardingData)));
        }
    }, []);

    const populateOnboardingDocuments = (onboardingData:any) => {
        if (!onboardingData) return;
        const tempState = JSON.parse(JSON.stringify(onboardingData));
        const { clientDirectory, portalSearch, emailHoa, callHoa }:any = tempState;
        const copyOfInitialOnboardingDocumentStateData = JSON.parse(JSON.stringify(initialOnboardingDocumentStateData));

        if (clientDirectory["data"].documents) {
            copyOfInitialOnboardingDocumentStateData["clientDirectory"] = clientDirectory["data"].documents;
        }
        if (portalSearch["data"].documents) {
            copyOfInitialOnboardingDocumentStateData["portalSearch"] = portalSearch["data"].documents;
        }
        if (emailHoa["data"].documents) {
            copyOfInitialOnboardingDocumentStateData["emailHoa"] = emailHoa["data"].documents;
        }
        if (emailHoa["data"].screenshot) {
            copyOfInitialOnboardingDocumentStateData["emailHoaScreenshot"] = emailHoa["data"].screenshot;
        }
        if (callHoa["data"].documents) {
            copyOfInitialOnboardingDocumentStateData["callHoa"] = callHoa["data"].documents;
        }
        if (callHoa["data"].screenshot) {
            copyOfInitialOnboardingDocumentStateData["callHoaScreenshot"] = callHoa["data"].screenshot;
        }

        setPreviousOnboardingDocuments(JSON.parse(JSON.stringify(copyOfInitialOnboardingDocumentStateData)));
        setOnboardingDocuments(JSON.parse(JSON.stringify(copyOfInitialOnboardingDocumentStateData)));
    }

    const countTabFields = (tabName: keyof Config): boolean => {
        const checkVisibility = (obj: NestedFieldConfig): boolean => {
          return Object.values(obj).every(value => {
            if ('isVisible' in value) {
              return !value.isVisible;
            }
            return checkVisibility(value as NestedFieldConfig);
          });
        };
      
        if(tabNames.hasOwnProperty(tabName) && Object.keys(selectedDataFieldConfigurator).length){
            if(tabName ==="Overview"){
                return false
            }
            return checkVisibility(selectedDataFieldConfigurator[tabName]);
        }
        else{
            return false
        }
      };

    useEffect(() => {
        if (onboardingDataState) {
            let isCompleted = true;
            let clientDirectoryStatus = false;
            let isBillableItemDisabled = false;

            for (const key of Object.keys(onboardingDataState)) {
                if (key == "clientDirectory" && onboardingDataState[key].isCompleted) {
                    clientDirectoryStatus = true;
                }

                if (!onboardingDataState[key].isCompleted) {
                    isCompleted = false;
                }
            }

            setIsOnboardingCompleted(isCompleted);
            setIsClientDirectoryCompleted(clientDirectoryStatus);

            let isJustCompleted = false;

            if (!previousOnboardingDataState["clientDirectory"].isCompleted && onboardingDataState["clientDirectory"].isCompleted) {
                isJustCompleted = true;
            }
            else {
                isJustCompleted = false;
            }

            setIsClientDirectoryJustCompleted(isJustCompleted);

            if (!clientDirectoryStatus || (clientDirectoryStatus && isJustCompleted)) {
                isBillableItemDisabled = true;
            }

            setIsOtherBillableItemsDisabled(isBillableItemDisabled);
        }
    }, [onboardingDataState]);

    useEffect(() => {
        if (selectedDataFieldConfigurator) {
            (Object.keys(tabNames) as TabNames[]).forEach((tab) => {
			if(tab === "Violation Regulation"){
					setRestrictedFields((prev:any) => ({
						...prev,
						[tabNames[tab]]: [
							...getPropertyNamesWithInvisibleFields(selectedDataFieldConfigurator[tab])
						]
					}));
			}
			 else if(tab !== "Overview"){
                setRestrictedFields((prev:any) => ({
                    ...prev,
                    [tabNames[tab]]: [
                        ...getFieldNamesWithInvisibleFields(selectedDataFieldConfigurator[tab])
                    ]
                }));
			 }
			 else{
				setRestrictedFields((prev:any) => ({
                    ...prev,
                    [tabNames[tab]]: [
                        ...getPropertyNamesWithInvisibleFields(selectedDataFieldConfigurator[tab])
                    ]
                }));
			 }
            });
        }
    }, [selectedDataFieldConfigurator]);

    useEffect(()=>{
        checkNewAmenitiesWarning(selectedValues?.newAvailableAmenities, selectedValues?.accessInformation,selectedValues?.amenityEvents)
    }, [selectedValues?.newAvailableAmenities,selectedValues?.accessInformation, selectedValues?.amenityEvents])

    useEffect(()=>{
        checkViolationWarning(violationRegulations)
    }, [violationRegulations, structureBuildingFiles])

    useEffect(() => {
        checkDocumentWarning(selectedValues.documents)
    }, [selectedValues.documents]);

    useEffect(() => {
        checkProcedureWarning(selectedValues.procedures)
    }, [selectedValues.procedures]);

    const createLogPayloadMaker = async (status:string,objectId:string,prevState?:any,updatedState?:any,type?:string,extensions?:any,billableItem?: string, client?: any, hoaDocumentToBeDeleted?: any, changedEventsAndFields?:any) => {
        // delete parseObjects
        let prev = {...prevState}
		delete prev._parseObject
        if(prev.municipality){
            delete prev.municipality._parseObject
        }
		let update = {...updatedState}
        if(update.municipality){
            delete update.municipality._parseObject
        }
		delete update._parseObject
        
        //delete masterHoa info
        if (prev.masterHoa) {
            delete prev.masterHoa;
        }
        if (update.masterHoa) {
            delete update.masterHoa;
        }

        // set default type
        if(!type) {
			type = 'Hoa'
		}

        // set primaryEvent
        var events:any = [];
		var primaryEvent = "";

        if(type == 'Hoa') {
			primaryEvent = config.changeLongActionsHoa[status];
            if(client && client.clientId && status === 'clientAssigned'){
                primaryEvent = `${primaryEvent} (${client.clientId})`;
            }
		}
		else if(type == 'Property') {
			primaryEvent = config.changeLongActionsProperty[status];
		}

        // manage extensions
        if(Array.isArray(extensions) && extensions.length > 0) {
            extensions.map(extension => {
                if(extension === 'Update Municipality Information' || extension === "Client Directory" || extension === "Portal Search" || extension === "Email HOA" || extension === "Call HOA") {
                    events.push(`${extension}`);
                } else {
                    events.push(`${primaryEvent} ${extension}`);
                }
            });
        }
        else {
            events.push(primaryEvent);
        }
        var logMessages: any[] = [];
        if(events.length > 0) {
            if(type == 'Hoa') {
                const logMessage = {
                    events:events,
                    initialEvents:events,
                    billItem: billableItem ? billableItem : selectedBillItem,
                    linkedEntryId: linkedEntryId,
                    effectiveDate: effectiveDate,
                    documentType: documentType,
                    evidenceLink: evidenceLink,
                    user: datastore.ownerInformation.name,
                    prevState:prev,
                    updatedState:update,
                    type:type,
                    tagTypeId:objectId,
                    sourceId: sourceId,
                    documentId: documentId,
                    sourceDocumentType: sourceDocumentType,
                    documents: isVerified?.attachmentDetails ? Array.isArray(isVerified?.attachmentDetails) ? isVerified?.attachmentDetails : [isVerified?.attachmentDetails?.name] : [],
                    hoaDocumentToBeDeleted: hoaDocumentToBeDeleted,
                    changedEventsAndFields:changedEventsAndFields || {}
                }
                logMessages.push(logMessage)
            }
            else if(type == 'Property') {
                const properties = await  dashboardServices.getPropertiesOfHoa(objectId, 20, 1);
                var propertiesIdsList: any[] = [];
                if(properties && properties.data && Array.isArray(properties.data) && properties.data.length) {
                    properties.data.map((property: any) => {
                        propertiesIdsList.push(property.objectId);
                    })
                }

                if(propertiesIdsList.length > 0) {
                    for(let i=0; i<propertiesIdsList.length; i++) {
                        logMessages.push({
                            events:events,
                            billItem: selectedBillItem,
                            linkedEntryId: linkedEntryId,
                            evidenceLink: evidenceLink,
                            user: datastore.ownerInformation.name,
                            prevState:prev,
                            updatedState:update,
                            type:type,
                            tagTypeId:propertiesIdsList[i],
                        })
                    }
                }
            }
        }
        return logMessages
    }
        
	const createLogsForHoa = async (logMessages:any, objectId:string) => {
        const result = await dashboardServices.createMultipleLogs(logMessages);
        saveNewLogsInDatastore(result.data, datastore);
        return result;
    }
        
    
	const createLogs = async (status:string,objectId:string,prevState?:any,updatedState?:any,type?:string,extensions?:any,billableItem?: string, client?: any, hoaDocumentToBeDeleted?: any, changedEventsAndFields?:any) => {
        // delete parseObjects
        let prev = {...prevState}
		delete prev._parseObject
        if(prev.municipality){
            delete prev.municipality._parseObject
        }
		let update = {...updatedState}
        if(update.municipality){
            delete update.municipality._parseObject
        }
		delete update._parseObject

        // delete masterHoa info
        if(prev.masterHoa){
            delete prev.masterHoa
        }
        if(update.masterHoa){
            delete update.masterHoa
        }

        // set default type
        if(!type) {
			type = 'Hoa'
		}

        // set primaryEvent
        var events:any = [];
		var primaryEvent = "";

        if(type == 'Hoa') {
			primaryEvent = config.changeLongActionsHoa[status];
            if(client && client.clientId && status === 'clientAssigned'){
                primaryEvent = `${primaryEvent} (${client.clientId})`;
            }
            if(status === 'clientRemoved') {
                primaryEvent = `Organization removed from HOA(${client})`
            }
		}
		else if(type == 'Property') {
			primaryEvent = config.changeLongActionsProperty[status];
		}

        // manage extensions
        if(Array.isArray(extensions) && extensions.length > 0) {
            extensions.map(extension => {
                if(extension === 'Update Municipality Information') {
                    events.push(`${extension}`);
                } else {
                    events.push(`${primaryEvent} ${extension}`);
                }
            });
        }
        else {
            events.push(primaryEvent);
        }

        if(events.length > 0) {
            if(type == 'Hoa') {
                const logMessage = {
                    events:events,
                    initialEvents:events,
                    billItem: billableItem ? billableItem : selectedBillItem,
                    linkedEntryId: linkedEntryId,
                    effectiveDate: effectiveDate,
                    documentType: documentType,
                    evidenceLink: evidenceLink,
                    user: datastore.ownerInformation.name,
                    prevState:prev,
                    updatedState:update,
                    type:type,
                    tagTypeId:objectId,
                    sourceId: sourceId,
                    documentId: documentId,
                    sourceDocumentType: sourceDocumentType,
                    documents: isVerified?.attachmentDetails ? Array.isArray(isVerified?.attachmentDetails) ? isVerified?.attachmentDetails : [isVerified?.attachmentDetails?.name] : [],
                    hoaDocumentToBeDeleted: hoaDocumentToBeDeleted,
                    changedEventsAndFields:changedEventsAndFields || {}
                }
                const result = await dashboardServices.createLogs(logMessage);
                saveNewLogsInDatastore(result.data, datastore);
            }
            else if(type == 'Property') {
                const properties = await  dashboardServices.getPropertiesOfHoa(objectId, 20, 1);
                var propertiesIdsList: any[] = [];
                if(properties && properties.data && Array.isArray(properties.data) && properties.data.length) {
                    properties.data.map((property: any) => {
                        propertiesIdsList.push(property.objectId);
                    })
                }

                if(propertiesIdsList.length > 0) {
                    var logMessages: any[] = [];
                    for(let i=0; i<propertiesIdsList.length; i++) {
                        logMessages.push({
                            events:events,
                            billItem: selectedBillItem,
                            linkedEntryId: linkedEntryId,
                            evidenceLink: evidenceLink,
                            user: datastore.ownerInformation.name,
                            prevState:prev,
                            updatedState:update,
                            type:type,
                            tagTypeId:propertiesIdsList[i],
                        })
                    }
    
                    const results = await dashboardServices.createMultipleLogs(logMessages);
                    saveNewLogsInDatastore(results.data, datastore);
                }
            }
        }
    }

    const isObjectEmpty = (object : any)=>{
        if(object) {
            for(const item of Object.values(object)){
                if(Array.isArray(item)){
                    if(item.length > 0)
                        return false;
                }
                else if(item && item !=='')
                    return false;
            }
        }
        return true;
    }

    const checkNewAmenitiesWarning = (newAvailableAmenities : any, accessInformation:any, amenityEvents:any) => {
        if(newAvailableAmenities?.length > 0 || accessInformation?.length>0 || amenityEvents?.length > 0 ){
            setNewAmenitiesWarning(false);
        } else {
            if(!newAmenitiesWarning){
                setNewAmenitiesWarning(true);
            }
        }
    }


    const checkViolationWarning = (violationRegulations : any) => {
        if(!isObjectEmpty(violationRegulations) || structureBuildingFiles.architecturalFiles.length>0 || structureBuildingFiles.structureChangeFiles.length>0){
            setViolationWarning(false);
        } else {
            if(!violationWarning){
            setViolationWarning(true);
            }
        }
    }

    const checkProcedureWarning = (Procedures: any) => {
        if (!isObjectEmpty(Procedures)) {
            setProcedureWarning(false);
        } else {
            if (!procedureWarning) {
                setProcedureWarning(true);
            }
        }
    }

    const checkDocumentWarning = (doc: any) => {
        if(doc){
            const empty = Object.values(doc).every((value:any)=>Object.values(value).length === 0)
            if(empty){
                setDocumentWarning(false)
            } else {
                setDocumentWarning(true)
            }
        } else {
            setDocumentWarning(false);
        }
    }

    const handleSaveModalClose = () => {
        setSaveModalOpen(false);
    }
    const handleSaveModalOpen = () => {
        if(currentHoa.hoaClientInfo && currentHoa.hoaClientInfo.length > 0){
            setSaveModalOpen(true);
        }else{
            onSaveClick();
        }
    }

    const isNewClientAdd = () => {
        const newClient = currentHoa.hoaClientInfo.filter((item: any) => {
            return !previousHoa?.hoaClientInfo?.some((info: any) => item.clientId === info.clientId);
        });
        return newClient;
    }

    function getRemovedClients() {
        if (!previousHoa || !previousHoa.hoaClientInfo) return [];
        if (!currentHoa || !currentHoa.hoaClientInfo) return previousHoa?.hoaClientInfo?.map((info: any) => info.clientId);
    
        return previousHoa?.hoaClientInfo
            .filter((info: any) => !currentHoa?.hoaClientInfo.some((item: any) => item.clientId === info.clientId))
            .map((info: any) => info.clientId);
    }

    const isStructureChangeFilesChanged = () => {
        return compareObjects(currentHoa.violationRegulations?.structure?.structureChangeFiles, previousHoa?.violationRegulations?.structure?.structureChangeFiles)
    };


    useEffect(() => {
        if (previousHoa && Object.keys(previousHoa).length && view === "update" && !isStructureChangeFilesChanged()) {
            setIsDisabled(false);
        }
    },[violationStructureBuildingFiles.structureChangeFiles])


    useEffect(() => {
        if(currentHoa && Object.keys(currentHoa).length > 0 && previousHoa && Object.keys(previousHoa).length > 0){
            if(view === 'update' && !isMunicipalityChange(previousHoa, currentHoa)){
                setIsDisabled(false);
            }
            if(view === 'update' && (!compareHoaBasicInfo(previousHoa, currentHoa) || !isClientInfoChanged(previousHoa, currentHoa))){
                setIsDisabled(false);
            }
            if(view === 'update' && !deepCompare(previousHoa?.newAvailableAmenities||[],newAvailableAmenities)){
                setIsDisabled(false);
            }
            if(view === 'update' && !deepCompare(previousHoa?.amenityEvents||[],amenityEvents)){
                setIsDisabled(false);
            }
            if(view === 'update' && !deepCompare(previousHoa?.hoaEvents||[],hoaEvents)){
                setIsDisabled(false);
            }
            if(view === 'update' && !deepCompare(previousHoa?.accessInformation||[],accessInformation)){
                setIsDisabled(false);
            }
            if(view === 'update' && (JSON.stringify(previousHoa.violationRegulations) != JSON.stringify(violationRegulations)) || structureBuildingFiles.architecturalFiles.length>0 || structureBuildingFiles.structureChangeFiles.length>0){
                setIsDisabled(false);
            }
            if(view === 'update' && (JSON.stringify(currentHoa.procedures) != JSON.stringify(previousHoa.procedures))|| sourceDocuments.length>0){
                setIsDisabled(false);
            }
            if(view === 'update' && (JSON.stringify(previousHoa.documents) != JSON.stringify(currentHoa.documents) || Object.keys(selectedHoaDocuments).length !== 0 || Object.keys(hoaDocumentToBeDeleted).length !== 0)){
                setIsDisabled(false);
            }
            if(view === 'update' && !deepCompare(onboardingDataState, previousOnboardingDataState)) {
                setIsDisabled(false);
            }
            if(view === 'update' && !deepCompare(onboardingDocuments, previousOnboardingDocuments)) {
                setIsDisabled(false);
            }
        }
    },[selectedValues, previousHoa, currentHoa, violationRegulations, structureBuildingFiles, selectedHoaDocuments, hoaDocumentToBeDeleted,accessInformation,newAvailableAmenities,amenityEvents,sourceDocuments, onboardingDataState, onboardingDocuments, hoaEvents])

    const onSaveClick = async () => {
        setCheckError(true);
        let HoaError = false;
        for (const [key, value] of Object.entries(currentHoa)) {
            if(currentHoa.email && !emailValid){
                HoaError = true;
                break;
            }
            if(currentHoa.phone && !phoneValid){
                HoaError = true;
                break;
            }
            if(!currentHoa.fees || !currentHoa.address || !currentHoa.zip || !currentHoa.coordinates || !currentHoa.name){
                HoaError = true;
                break;
            }
            if(currentHoa.propertyManagementCompanyAvailable && !currentHoa.propertyManager?.propertyManagerName && !currentHoa.propertyManager?.propertyManagerCompanyAddress){
                HoaError = true;
                break;
            }
        }
        for(const [key, value] of Object.entries(violationRegulations)){
            if(violationRegulations?.structure?.buildingOptions?.structureHyperLink && !isValidHttpUrl(violationRegulations.structure.buildingOptions.structureHyperLink)){
                HoaError = true;
                break;
            }
            if(violationRegulations?.structure?.buildingOptions?.architectureHyperLink && !isValidHttpUrl(violationRegulations.structure.buildingOptions.architectureHyperLink)){
                HoaError = true;
                break;
            }
            if(violationRegulations.structure?.buildingOptions?.email && !isEmailValid(violationRegulations.structure?.buildingOptions?.email)){
                HoaError = true;
                break;
            }
            if(violationRegulations.structure?.buildingOptions?.phone && !isPhoneValid(violationRegulations.structure?.buildingOptions?.phone)){
                HoaError = true;
                break;
            }
        }
        if(HoaError && saveModalOpen){
            handleSaveModalClose();
        }
        if(!HoaError){
         try{
            setLoading(true);
            setShowApiErrorModal(false)
            handleSaveModalClose();
            if (view === "add") {
                let tempState: any = { ...currentHoa };
                tempState.numberOfProperties = 0;
                tempState.numberOfPropertiesByOrg = [];
                const res = await dashboardServices.addHoa(tempState);

                const masterHoaExtensions:any = [];
                if (res.data.masterHoaId) {
                    masterHoaExtensions.push(`as Sub (Master HOA ID: ${res.data.masterHoaId})`);
                }
                else {
                    masterHoaExtensions.push('as Master');
                }
                const changedEventsAndFields:any={}
                const excludeAmenityKeys = ['additionalAmenitiesDocument', 'amenityPhotos', 'poolAccessFormFiles'];

                if(!compareHoaBasicInfo({}, res.data)){
                    masterHoaExtensions.push('Update HOA Overview Information');
                    const {existingObj,newObj} =prepareBasicInforObject({},res.data)
                    changedEventsAndFields["Update HOA Overview Information"]= deepCompareFieldsWithPaths(existingObj,newObj)
                }
                await createLogs(props.view, res.data.objectId,{},res.data, null, masterHoaExtensions,null,null,null,changedEventsAndFields)
                const newHoaClient = isNewClientAdd();

                if(newHoaClient.length > 0 && isClientDirectoryCompleted){
                    const billableItem = "Trigger due to Vendor Association";
                    for (let client of newHoaClient) {
                        await createLogs('clientAssigned', res.data.objectId, {}, res.data, null, [], billableItem, client);
                    }
                }
                if (res.status === 200) {
                    props.setSuccess(true);
                    const tmpData: any = [res.data, ...hoa.data];
                    updateHoaData({
                        ...hoa,
                        data: tmpData,
                    });
                }
                props.setView("list");
            } else if(props.view === "update"){
                let extensions: any = [];
                let data = hoa.data;
                let index = 0;
                let selectedHoa: any = {};
                if(Array.isArray(data) && data.length>0){
                    selectedHoa = data.find((value: any, index1: number) => {
                        if(value.objectId === selectedValues.objectId){
                            index = index1;
                            return value;
                        }
                    });
                }else{
                    selectedHoa = previousHoa;
                }

                if(Object.keys(currentHoa).length !== 0 ){
                    selectedHoa = currentHoa;
                }
                selectedHoa.objectId  = selectedValues.objectId;
                const excludeAmenityKeys = ['additionalAmenitiesDocument', 'amenityPhotos', 'poolAccessFormFiles'];

                const changedEventsAndFields:any = {}
                if(previousHoa?.municipality?.objectId !== selectedHoa?.municipality?.objectId) {
                    extensions.push('Update Municipality Information');
                } 
                if(!compareHoaBasicInfo(selectedValues, selectedHoa)){
                    extensions.push('Update HOA Overview Information');
                    const {existingObj,newObj} =prepareBasicInforObject(selectedValues,selectedHoa)
                    changedEventsAndFields["Update HOA Overview Information"]= deepCompareFieldsWithPaths(existingObj,newObj)
                }
                if(deepCompare(previousHoa?.newAvailableAmenities||[], newAvailableAmenities) === false || deepCompare(previousHoa?.amenityEvents||[], amenityEvents) === false|| deepCompare(previousHoa?.accessInformation||[], accessInformation) === false ){
                    extensions.push('Amenities Information');
                    changedEventsAndFields["Update HOA Amenities Information"]=[]

                    if(deepCompare(previousHoa?.newAvailableAmenities||[], newAvailableAmenities) === false){
                        changedEventsAndFields["Update HOA Amenities Information"].push(...deepCompareFieldsWithPaths(previousHoa?.newAvailableAmenities||[], newAvailableAmenities,[""],"newAvialableAmenities"))
                    }
                    if(deepCompare(previousHoa?.amenityEvents||[], amenityEvents) === false){
                        changedEventsAndFields["Update HOA Amenities Information"].push(...deepCompareFieldsWithPaths(previousHoa?.amenityEvents||[], amenityEvents,[""], "amenityEvents"))
                    }
                    if(deepCompare(previousHoa?.accessInformation||[], accessInformation) === false){
                        changedEventsAndFields["Update HOA Amenities Information"].push(...deepCompareFieldsWithPaths(previousHoa?.accessInformation||[], accessInformation))
                    }
                }     
                if((JSON.stringify(selectedValues.violationRegulations) != JSON.stringify(violationRegulations)) || structureBuildingFiles.architecturalFiles.length>0 || structureBuildingFiles.structureChangeFiles.length>0 || !isStructureChangeFilesChanged()){
                    extensions.push('Violation Information')
                    changedEventsAndFields["Update HOA Violation Information"]=[]
                    if(JSON.stringify(selectedValues.violationRegulations) != JSON.stringify(violationRegulations)){
                        changedEventsAndFields["Update HOA Violation Information"]=[...changedEventsAndFields["Update HOA Violation Information"],...deepCompareFieldsWithPaths(Object.keys(selectedValues.violationRegulations).length?selectedValues.violationRegulations:violatioRegulationObj,violationRegulations,["architecturalFiles","structureChangeFiles"],"violation")]
                    }
                    if(structureBuildingFiles?.architecturalFiles.length>0){
                        changedEventsAndFields["Update HOA Violation Information"].push("architecturalFiles")
                    }
                    if(structureBuildingFiles?.structureChangeFiles.length>0){
                        changedEventsAndFields["Update HOA Violation Information"].push("structureChangeFiles")
                    }
                }
                if(JSON.stringify(previousHoa.documents) != JSON.stringify(currentHoa.documents) || Object.keys(selectedHoaDocuments).length !== 0 || Object.keys(hoaDocumentToBeDeleted).length !== 0){
                    extensions.push('Document Information')

                    const uniqueDocuments = new Set();

                    if (Object.keys(selectedHoaDocuments).length !== 0) {
                        Object.keys(selectedHoaDocuments).forEach(doc => uniqueDocuments.add(doc));
                    }
                
                    if (Object.keys(hoaDocumentToBeDeleted).length !== 0) {
                        Object.keys(hoaDocumentToBeDeleted).forEach(doc => uniqueDocuments.add(doc));
                    }
                
                    if (!changedEventsAndFields["Update HOA Document Information"]) {
                        changedEventsAndFields["Update HOA Document Information"] = [];
                    }
                
                    changedEventsAndFields["Update HOA Document Information"] = [...uniqueDocuments];
                }
                if(!compareProcedure(previousHoa.procedures, selectedHoa.procedures) || sourceDocuments.length>0){
                    extensions.push('Procedures Information')
                    changedEventsAndFields["Update HOA Procedures Information"]= deepCompareFieldsWithPaths(previousHoa.procedures,selectedHoa.procedures)  
                    if(sourceDocuments.length>0){
                        changedEventsAndFields["Update HOA Procedures Information"].push("sourceDocuments")
                    }
                }

                let existingStructureChangeFiles = [];
                let existingArchitecturalFiles = [];

                if(selectedHoa?.violationRegulations && selectedHoa?.violationRegulations.structure?.structureChangeFiles){
                    existingStructureChangeFiles = selectedHoa?.violationRegulations.structure?.structureChangeFiles;
                }
                if(selectedHoa?.violationRegulations && selectedHoa?.violationRegulations.structure?.architecturalFiles){
                    existingArchitecturalFiles = selectedHoa?.violationRegulations.structure?.architecturalFiles;
                }

                selectedHoa.newAvailableAmenities= [...newAvailableAmenities]
                selectedHoa.amenityEvents =[...amenityEvents]
                selectedHoa.accessInformation=[...accessInformation]

                selectedHoa.violationRegulations = {...violationRegulations};
                if(selectedHoa.violationRegulations?.structure?.structureChangeFiles){
                    selectedHoa.violationRegulations.structure.structureChangeFiles = existingStructureChangeFiles;
                }
                if(selectedHoa.violationRegulations?.structure?.architecturalFiles){
                    selectedHoa.violationRegulations.structure.architecturalFiles = existingArchitecturalFiles;
                }
                if((structureBuildingFiles.architecturalFiles.length>0 || structureBuildingFiles.structureChangeFiles.length>0) && selectedHoa.violationRegulations?.structure === undefined){
                    selectedHoa.violationRegulations = {
                    ...selectedHoa.violationRegulations,
                    structure: {}
                    }
                }

                selectedHoa.documents = selectedValues.documents ? selectedValues.documents : initialDocuments;
                selectedHoa.numberOfProperties = selectedValues.numberOfProperties;
                selectedHoa.numberOfPropertiesByOrg = selectedValues.numberOfPropertiesByOrg;

                let updatedCoreDocuments:any = {}

                // check of effective date exists
                if (effectiveDate && shouldApplyEffectiveDate(effectiveDate)) {
                    // create change log for this effective date

                    // handle hoa core documents before checking effective date
                    updatedCoreDocuments = await dashboardServices.updateHoaCoreDocuments(selectedHoa, selectedHoaDocuments);

                    const selectedHoaCopy = JSON.parse(JSON.stringify(selectedHoa));
                    selectedHoaCopy.documents = updatedCoreDocuments;

                    if(Object.keys(hoaDocumentToBeDeleted).map(async (key: any, index: any) => {
                        if(hoaDocumentToBeDeleted[key].length > 0){
                            Object.entries(selectedHoaCopy.documents).map(([key, value]: any) => {
                                if(value && value?.files && value?.files.length <= 0){
                                    selectedHoaCopy.documents[key] = {};
                                }
                            })
                        }
                    }))
                    
                    await createLogs(props.view,selectedValues.objectId,previousHoa,selectedHoaCopy,null, extensions, null, null, hoaDocumentToBeDeleted,changedEventsAndFields);
                    const updatedSelectedValue = await dashboardServices.getHoaById(selectedValues.objectId, datastore.selectedOrganization?.id);
                    
                    updateHoaDocumentToBeDeleted({});
                    updateSelectedHoaDocuments({});
                    updateAmenitiesDocImage({});

                    updateSelectedValues(updatedSelectedValue?.data);
                    data[index] = updatedSelectedValue?.data;
                    updateHoaData({
                        ...hoa,
                        data: data,
                    });

                    props.setSuccess(true);
                    setNewAvailableAmenities(selectedHoa.newAvailableAmenities);
                    setAmenityEvents(selectedHoa.amenityEvents)
                    setHoaEvents(selectedHoa.hoaEvents)
                    setAccessInformation(selectedHoa.accessInformation)
                    setViolationRegulations(selectedHoa.violationRegulations);
                    checkNewAmenitiesWarning(selectedHoa?.newAvailableAmenities,selectedHoa?.accessInformation, selectedHoa?.amenityEvents)
                    setSourceDocuments([])
                    setStructureBuildingFiles({
                        structureChangeFiles : [],
                        architecturalFiles: []
                    })
                    
                    // save previous hoa
                    props.setView("view");
                }
                else {
                    // delete hoa amenities document and images
                    Object.keys(amenitiesDocImage).map(async (key: any, index: number) => {
                        if(amenitiesDocImage[key].length>0){
                            if(key === 'amenityPhotos'){
                                for(let photo of amenitiesDocImage[key]){
                                    const DeletedPhoto = {
                                        name: photo.fileName
                                    }
                                    await dashboardServices.deletePhotos(DeletedPhoto, selectedValues.objectId, key);
                                }
                            }else{
                                for(let docs of amenitiesDocImage[key]){
                                    const doc = {
                                        name: docs.fileName,
                                        type: 'amenitiesDocument'
                                    }
                                    await dashboardServices.deleteDocuments(doc, selectedValues.objectId, key);
                                }
                            }
                        }
                    })
    
                    Object.keys(hoaDocumentToBeDeleted).map(async (key: any, index: any) => {
                        if(hoaDocumentToBeDeleted[key].length > 0){
                            hoaDocumentToBeDeleted[key].map(async (docs: any) => {
                                const doc = {
                                    name: index + docs.name,
                                    type: 'hoaDocument'
                                }
                                await dashboardServices.deleteDocuments(doc, selectedValues.objectId, key);
                            })
                            Object.entries(selectedValues.documents).map(([key, value]: any) => {
                                if(value && value?.files && value?.files.length <= 0){
                                    selectedValues.documents[key] = {};
                                    updatedCoreDocuments[key]={}
                                }
                            })
                        }
                    })

                    data[index] = selectedHoa;

                    
                    updateHoaDocumentToBeDeleted({});
                    updateSelectedHoaDocuments({});
                    updateAmenitiesDocImage({});             
                    if(true){
                        const updatedOnBodingState = await dashboardServices.updateHoaOnboardingData(selectedValues.objectId, onboardingDataState, onboardingDocuments);
                        const newOnboardingData = updatedOnBodingState || JSON.parse(JSON.stringify(initialHoaOnboardingData));
                        const onboardingChangeEvents:any = getOnboardingChangeEvents(previousOnboardingDataState, newOnboardingData);
                        
                        await dashboardServices.updateDocumentFiles(selectedHoa, selectedHoaDocuments, structureBuildingFiles, sourceDocuments,updatedOnBodingState)

                        if(Array.isArray(onboardingChangeEvents) && onboardingChangeEvents.length > 0) {
                            extensions = [...extensions, ...onboardingChangeEvents];
                        }
                        
                        // console.log(compareObjects(selectedHoa, currentHoa), selectedHoa, currentHoa)
                        // handle master hoa changelog event
                        const masterHoaExtensions:any = [];
                        let extentionsLogEvents:any=[]
                        if (currentHoa?.masterHoaId && (previousHoa?.masterHoaId != currentHoa?.masterHoaId)) {
                            masterHoaExtensions.push(`as Sub (Master HOA ID: ${currentHoa?.masterHoaId})`);
                        }
                        else if (previousHoa?.masterHoaId && !currentHoa?.masterHoaId) {
                            masterHoaExtensions.push('as Master');
                        }

                        if(Array.isArray(masterHoaExtensions) && masterHoaExtensions.length > 0){
                            const masterExtentionsLogs=await createLogPayloadMaker(props.view,selectedValues.objectId,{},{},null, masterHoaExtensions)
                            if (Array.isArray(masterExtentionsLogs) && masterExtentionsLogs.length > 0) {
                                extentionsLogEvents=[...extentionsLogEvents,...masterExtentionsLogs]
                            }
                        }
                        
                        // handle rest of the changelog events
                        if(Array.isArray(extensions) && extensions.length>0){
                            const previousData = {
                                ...previousHoa, 
                                onboardingData: previousOnboardingDataState
                            }
                            const currentData = {
                                ...currentHoa, 
                                onboardingData: newOnboardingData
                            }
                            const extentionsLogs = await createLogPayloadMaker(props.view,selectedValues.objectId, previousData, currentData ,null, extensions,null,null,null,changedEventsAndFields);
                            if (Array.isArray(extentionsLogs) && extentionsLogs.length > 0) {
                                extentionsLogEvents=[...extentionsLogEvents,...extentionsLogs]
                            }
                        }

                        if(Array.isArray(extentionsLogEvents) && extentionsLogEvents.length > 0) {
                            const createdLogs = await createLogsForHoa(extentionsLogEvents, selectedValues.objectId)
                        }
                        const res = await dashboardServices.updateHoa(selectedHoa,selectedHoaDocuments, structureBuildingFiles, sourceDocuments,updatedOnBodingState);
                        data[index].updatedAt = res?.data?.updatedAt;

                        const newHoaClient = isNewClientAdd();
                        //hoa clients exist but client directory just now completed, create log for existing clients
                        if (isClientDirectoryJustCompleted && res.data) {
                            const billableItem = "Trigger due to Vendor Association";
                            await Promise.all(
                                currentHoa.hoaClientInfo.map((client:any) =>
                                    createLogs('clientAssigned', res.data.objectId, previousHoa, res.data, null, [], billableItem, client)
                                )
                            );

                        } // new clients added and client directory just now completed, create log for new clients
                        else if(Array.isArray(newHoaClient) && newHoaClient.length > 0 && isClientDirectoryCompleted && res.data){
                            const billableItem = "Trigger due to Vendor Association";
                            await Promise.all(
                                newHoaClient.map((client:any) =>
                                    createLogs('clientAssigned', res.data.objectId, previousHoa, res.data, null, [], billableItem, client)
                                )
                            );
                        } // hoa client removed
                        if(getRemovedClients()?.length > 0 && res.data) {
                            const clientIds = getRemovedClients();
                            await Promise.all(
                                clientIds.map((client:any) =>
                                    createLogs('clientRemoved', res.data.objectId, previousHoa, res.data, null, [], null, client)
                                )
                            )
                            await revertAddClientLog(res.data.objectId, clientIds);
                        }
                        updateHoaData({
                            ...hoa,
                            data: data,
                        });
                        props.setSuccess(true);

                        // handle onboarding -- starts

                        setOnboardingDataState(JSON.parse(JSON.stringify(newOnboardingData)));
                        setPreviousOnboardingDataState(JSON.parse(JSON.stringify(newOnboardingData)));
                        populateOnboardingDocuments(JSON.parse(JSON.stringify(newOnboardingData)));
                        // handle onboarding -- ends

                        setCurrentHoa(res.data);
                        updateSelectedValues(selectedHoa);
                        setNewAvailableAmenities(selectedHoa.newAvailableAmenities);
                        setHoaEvents(selectedHoa.hoaEvents)
                        setAmenityEvents(selectedHoa.amenityEvents)
                        setAccessInformation(selectedHoa.accessInformation)
                        setViolationRegulations(selectedHoa.violationRegulations);
                        checkNewAmenitiesWarning(selectedHoa?.newAvailableAmenities,selectedHoa?.accessInformation, selectedHoa?.amenityEvents)
                        setSourceDocuments([])
                        setStructureBuildingFiles({
                            structureChangeFiles : [],
                            architecturalFiles: []
                        })
                        props.setView("view");
                    }
                }
            }
            setEffectiveDate(null);
            setLoading(false);
        
        }
        catch(error){
            console.log(error)
            window.alert(error)
            setLoading(false)
            setShowApiErrorModal(true)
        }}
        setIsDisabled(true);
    }

    const onDeleteClick = async () => {
        setLoading(true);
        await createLogs('remove',selectedValues.objectId);
        await createLogs('deleteHoa', selectedValues.objectId, {}, {}, 'Property');
        const {data} = await dashboardServices.removeHOA(selectedValues.objectId);
        if(data.removedHoa){
            const updatedData = hoa.data.filter(((value:any) => value.objectId !== selectedValues.objectId))
            updateHoaData({
                ...hoa,
                data: updatedData,
            });
            if(data.updatedProperties && data.updatedProperties.length){
                let propertyData = property.data;
                propertyData.map((prop: any, index: number) => {
                    data.updatedProperties.filter((each: any) => {
                        if(each.objectId === prop.objectId){
                            propertyData[index] = each;
                        }
                    })
                })
                updatePropertyData({
                    ...property,
                    data: propertyData,
                });
            }
            setSuccess(true);
            changeActiveMenu(activeMenu,false, "", -1);
            updateView('remove-from-list')
            setLoading(false);
        }
    }

    const onCancelYesClick = async () => {
        // changeActiveMenu(activeMenu,false, "", -1);
        updateHoaDocumentToBeDeleted({});
        updateSelectedHoaDocuments({});
        updateAmenitiesDocImage({});
        updateViolationStructureBuildingFiles({});
        setCurrentHoa({});
        setCurrentMasterHoa(null);
        setSourceDocuments([]);
        setMasterHoas([]);
        setSelectedMunicipality({});
        updateSelectedValues(selectedValues);
        setHoaEvents(selectedValues.hoaEvents);
        setAmenityEvents(selectedValues.amenityEvents);
        setAccessInformation(selectedValues.accessInformation);
        setNewAvailableAmenities(selectedValues.newAvailableAmenities);
        setViolationRegulations(previousHoa.violationRegulations);
        checkNewAmenitiesWarning(selectedValues?.newAvailableAmenities,selectedValues?.accessInformation, selectedValues?.amenityEvents);
        checkViolationWarning(selectedValues.violationRegulations);
        checkProcedureWarning(selectedValues.procedures);
        setIsDisabled(true);

        setStructureBuildingFiles({
            structureChangeFiles : [],
            architecturalFiles: []
        });
        populateOnboardingDocuments(selectedValues.onboardingData || initialHoaOnboardingData)
        setOnboardingDataState(selectedValues.onboardingData || initialHoaOnboardingData);
        if (Object.keys(selectedValues).length > 0) {
            selectedValues.documents = previousHoa?.documents;
            selectedValues.procedures = previousHoa?.procedures;
            selectedValues.amenities = previousHoa?.amenities;
            selectedValues.violationRegulations = previousHoa?.violationRegulations; 
			setView("view");
		}else {
			setView("list");
		}
        setIsCancelClicked(false);
    }

    const onCancelClick = () => {
        setIsCancelClicked(!isCancelClicked);
    }

    const onUpdateClick = async () => {
        if (activeTab === 6) {
            updateActiveTab(0)
        }
        setView("update");
    }

    const getMunicipalities = async (data : any) =>{
        const {data: allMunicipalities} = await dashboardServices.getMunicipalities(100, 1, data);
        return {
            municipalities: allMunicipalities.municipalities,
            count: allMunicipalities.parseCount
        }
    }

    const proceedToAdd = () => {
        if(selectedValues && selectedValues.name){
            setView('update')
        } else {
            setView("add");
        }
    }

    const goToSelectMunicipality = () => {
        setView("selectMunicipality");
    }

    const shouldShowClientChargeWarning = () => {
        const newClient = isNewClientAdd();

        if(isClientDirectoryJustCompleted && Array.isArray(currentHoa.hoaClientInfo) && currentHoa.hoaClientInfo.length > 0) {
            return true;
        }
        else if (isClientDirectoryCompleted && newClient.length > 0) {
            return true;
        }

        return false;
    }

    const isLabelWithWarning = (title: string) => {

        let labelWithWarning = null;
        if (title === 'Amenities' && newAmenitiesWarning) {
            labelWithWarning = (
                <Badge
                    style={{ textTransform: "none" }}
                    badgeContent={"i"}
                    color="warning"
                >
                    <div style={{ marginRight: "10px" }}>{title}</div>
                </Badge>
            );
        } else if (title === 'Violation Regulation' && violationWarning) {
            labelWithWarning = (
                <Badge
                    style={{ textTransform: "none" }}
                    badgeContent={"i"}
                    color="warning"
                >
                    <div style={{ marginRight: "10px" }}>{title}</div>
                </Badge>
            );
        } else if (title === 'Documents' && !documentWarning) {
            labelWithWarning = (
                <Badge
                    style={{ textTransform: "none" }}
                    badgeContent={"i"}
                    color="warning"
                >
                    <div style={{ marginRight: "10px" }}>{title}</div>
                </Badge>
            );
        } else if (title === 'Procedures' && procedureWarning) {
            labelWithWarning = (
                <Badge
                    style={{ textTransform: "none" }}
                    badgeContent={"i"}
                    color="warning"
                >
                    <div style={{ marginRight: "10px" }}>{title}</div>
                </Badge>
            );
        }

        return labelWithWarning;
    }
    
    return (
		<div className="main-hoa-container" style={{ height:`${window.innerHeight - 98}px`}}>
            <LoadingComponent loading={loading} />
            <DeleteContainerModal type={'HOA'} onDeleteClick={onDeleteClick} isDeleteModal={isDeleteModal} setIsDeleteModal={setIsDeleteModal} />
            <BillableItemsModal 
                billItems={datastore.billableItemsOptions.hoa}
                selectedBillItem={selectedBillItem}
                setSelectedBillItem={setSelectedBillItem}
                evidenceLink={evidenceLink}
                setEvidenceLink={setEvidenceLink}
                onSaveClick={onSaveClick}
                isBillableItemsModal={isBillableItemsModal}
                setIsBillableItemsModal={setIsBillableItemsModal} 
                tagType={'Hoa'} 
                setLoading={setLoading}
                view={'add'}
                isNewClientAdd={isNewClientAdd}
                handleSaveModalOpen={handleSaveModalOpen}
                sourceId={sourceId}
				setSourceId={setSourceId}
				isVerified={isVerified}
				setIsVerified={setIsVerified}
                sourceDocumentType={sourceDocumentType}
    			setSourceDocumentType={setSourceDocumentType}
                effectiveDate={effectiveDate}
                setEffectiveDate={setEffectiveDate}
                documentType={documentType}
                setDocumentType={setDocumentType}
                isOtherBillableItemsDisabled={isOtherBillableItemsDisabled}
                shouldShowClientChargeWarning={shouldShowClientChargeWarning}
                linkedEntryId={linkedEntryId}
                setLinkedEntryId={setLinkedEntryId}
                documentId={documentId}
				setDocumentId={setDocumentId}
				isDocumentIdVerified={isDocumentIdVerified}
				setIsDocumentIdVerified={setIsDocumentIdVerified}
            />
            <SaveComponent
                handleSaveModalClose={handleSaveModalClose}
                onSaveClick={onSaveClick}
                saveModalOpen={saveModalOpen}
            />
            <TryagainModal
            open={showApiErrorModal}
            errorMessage="Save failed. Please try again."
            onClose={()=>setShowApiErrorModal(false)}
            onTryAgain={onSaveClick}
            />
            <EditCancelConfirmationModal 
                isCancelClicked={isCancelClicked}
                setIsCancelClicked={setIsCancelClicked}
                onCancelYesClick={onCancelYesClick}
                isDisabled={isDisabled}
                view={view}
            />
            
            {
                view !== 'selectMunicipality' &&
                <SubHeaderComponent
                    view={view}
                    warning={false} //!(!amenitiesWarning &&  violationWarning && documentWarning)
                    loading={loading}
                    selectedValues={selectedValues}
                    tagType={"HOA"}
                    selectedTabTitle={hoaTabTitles[activeTab]}
                    onSaveClick={handleSaveModalOpen}
                    onDeleteClick={()=>setIsDeleteModal(true)}
                    onCancelClick={onCancelClick}
                    onUpdateClick={onUpdateClick}
                    editOptionEnabledFromView={
                        !['Properties', 'Change Log'].includes(hoaTabTitles[activeTab])
                    }
                    setIsBillableItemsModal={setIsBillableItemsModal}
                    isDisabled={isDisabled}
                    onCancelYesClick={onCancelYesClick}
                />
            }
            {/* {
                (!selectedValues?.municipality?.name || loading) && <LinearProgress style={{margin:"5px 0px"}}/>
            } */}
			<>
                {view === "selectMunicipality" && (
					<HoaSelectMunicipalityForm height={window.innerHeight - 96} getMunicipalities={getMunicipalities} proceedToAdd={proceedToAdd} selectedMunicipality = {selectedMunicipality} setSelectedMunicipality={setSelectedMunicipality}  onCancelYesClick={onCancelYesClick}/>
				)}
				{view === "add" && (
                    <HoaBasicForm 
                        state={basicFormState} 
                        setState={setBasicFormState} 
                        setCurrentHoa = {setCurrentHoa} 
                        checkError={checkError} 
                        height={window.innerHeight - datastore.responsiveHeight} 
                        selectedMunicipality = {selectedMunicipality} 
                        view={view} 
                        selectedValues={selectedValues} 
                        error={error}
                        setError={setError} 
                        emailValid={emailValid} 
                        phoneValid={phoneValid} 
                        setEmailValid={setEmailValid} 
                        setPhoneValid = {setPhoneValid}
                        masterHoas={masterHoas}
                        setMasterHoas={setMasterHoas}
                        currentMasterHoa={currentMasterHoa}
                        setCurrentMasterHoa={setCurrentMasterHoa}
                        updateHoaData={updateHoaData}
                        updateSelectedValues={updateSelectedValues}
                        hoaEvents={hoaEvents}
                        setHoaEvents={setHoaEvents}
                        hoa={hoa}
                        previousHoa={previousHoa}
                        onboardingDataState={onboardingDataState}
                        previousOnboardingDataState={previousOnboardingDataState}
                        setOnboardingDataState={setOnboardingDataState}
                        onboardingDocuments={onboardingDocuments}
                        setOnboardingDocuments={setOnboardingDocuments}
                        populateOnboardingDocuments={populateOnboardingDocuments}
                        />
				)}
				{view !== "add" && view !== "selectMunicipality" && (
					<>
                        {
                            view === 'update' &&
                            <div style={{ display:'flex', alignItems:'center'}}>
                                <Button
                                    onClick={() => goToSelectMunicipality()}
                                    style={{ marginLeft: '8px' }}
                                    color="primary"
                                    startIcon={<ArrowBackIcon/>}
                                >
                                    Go To Select Municipality
                                </Button>
                                {/* <span className="text-3576E5-16px">Go To Select Municipality</span> */}
                            </div>
                        }
						<div style={{ borderBottom: "1px solid #E8E8E8" }}>
							<Tabs
								value={activeTab}
								onChange={(event:any, value) => {
									updateActiveTab(value);
								}}
							>
								{hoaTabTitles
									.map((title: string, index: number) => {
                                        if (view === "update" && title === "Change Log") return;
										else if (view === "update" && title === "Properties") return;
										return (
											<Tab
												key={index}
												label={isLabelWithWarning(title) || title}
												value={index}
												style={{ minWidth: "143px", textTransform: "none", display:countTabFields(title) ? "none":"inherit"}}
											/>
										);
									})
									.filter((value:any) => value !== undefined)}
							</Tabs>
						</div>
                        <div
                            style={{
                                height: window.innerHeight - datastore.responsiveHeightWithtab,
                                overflowY: "auto",
                            }}
                        >
							{view === "view" && (
								<HoaViewMainDashboard
                                    previousHoa={previousHoa}
                                    currentHoa={currentHoa}
                                    setCurrentHoa={setCurrentHoa}
                                    view={view}
									tabIndex={activeTab}
									selectedValues={selectedValues}
                                    newAmenitiesWarning={newAmenitiesWarning}
                                    violationWarning={violationWarning}
                                    procedureWarning={procedureWarning}
                                    documentWarning={documentWarning}
                                    setDocumentWarning={setDocumentWarning}
                                    height= {window.innerHeight - datastore.responsiveHeightWithtab - 111}
                                    setReloadFutureEffectiveDateLog={setReloadFutureEffectiveDateLog}
                                    restrictedFields={restrictedFields}
                                    isOtherBillableItemsDisabled={isOtherBillableItemsDisabled}
                                    onboardingDataState={onboardingDataState}
								/>
							)}
							{view === "update" && (
								<HoaUpdateMainDashboard
									tabIndex={activeTab}
                                    selectedValues={selectedValues}
                                    hoa={hoa}
                                    previousHoa={previousHoa}
                                    updateHoaData={updateHoaData}
                                    updateSelectedValues={updateSelectedValues}
                                    setCurrentHoa={setCurrentHoa}
                                    currentHoa={currentHoa}
                                    newAvailableAmenities={newAvailableAmenities}
                                    setNewAvailableAmenities={setNewAvailableAmenities}
                                    amenityEvents={amenityEvents}
                                    setAmenityEvents={setAmenityEvents}
                                    accessInformation={accessInformation}
                                    setAccessInformation={setAccessInformation}
                                    checkError={checkError}
                                    height={window.innerHeight - datastore.responsiveHeight - 48}
                                    selectedMunicipality = {selectedMunicipality}
                                    view={view}
                                    error={error}
                                    setError={setError}
                                    checkNewAmenitiesWarning={checkNewAmenitiesWarning}
                                    setDocumentWarning={setDocumentWarning}
                                    emailValid={emailValid}
                                    phoneValid={phoneValid}
                                    setEmailValid={setEmailValid}
                                    setPhoneValid = {setPhoneValid}
                                    setViolationRegulations = {setViolationRegulations}
                                    checkViolationWarning = {checkViolationWarning}
                                    checkDocumentWarning={checkDocumentWarning}
                                    checkProcedureWarning={checkProcedureWarning}
                                    basicFormState={basicFormState} 
                                    setBasicFormState={setBasicFormState}
                                    structureBuildingFiles={structureBuildingFiles}
                                    setStructureBuildingFiles={setStructureBuildingFiles}
                                    masterHoas={masterHoas}
                                    setMasterHoas={setMasterHoas}
                                    currentMasterHoa={currentMasterHoa}
                                    setCurrentMasterHoa={setCurrentMasterHoa}
                                    setSourceDocuments={setSourceDocuments}
                                    sourceDocuments={sourceDocuments}
                                    hoaEvents={hoaEvents}
                                    setHoaEvents={setHoaEvents}
                                    onboardingDataState={onboardingDataState}
                                    previousOnboardingDataState={previousOnboardingDataState}
                                    setOnboardingDataState={setOnboardingDataState}
                                    onboardingDocuments={onboardingDocuments}
                                    setOnboardingDocuments={setOnboardingDocuments}
                                    populateOnboardingDocuments={populateOnboardingDocuments}
								/>
							)}
						</div>
					</>
				)}
			</>
		</div>
	);
}

const SaveComponent = ({handleSaveModalClose, saveModalOpen, onSaveClick}: any) => {

    return(
        <Modal open={saveModalOpen} onClose={handleSaveModalClose}>
			<Container
				style={{
					background: "white",
					position: "absolute",
					top: "50%",
					left: "50%",
					transform: "translate(-50%, -50%)",
					width: "548px",
					maxHeight: "645px",
					overflow: "auto",
					borderRadius: "8px 8px 0px 0px",
					padding: "0px",
				}}
			>
				<div className="modal-wrapper-doc">
					<Stack
						style={{ 
							alignItems: "center",
							padding: '12px 24px',
							gap: '12px',	
						}}
						direction={"row"}
						spacing={1}
						justifyContent="flex-between">
						<SaveIcon 
							style={{color: '#F44336', fontSize: '58px', border: "1px solid #EF5350", borderRadius: "50%", padding: '10px'}}/>
						<div>
							<h2 style={{color: '#3E3E3E'}}>Are you sure you want to save?</h2>
							<p style={{color: '#787878'}}>Save changes will charge the client, Do you want to proceed?</p>
						</div>
					</Stack>
					
					<Stack
						style={{ marginTop: "24px" }}
						direction={"row"}
						spacing={1}
						justifyContent="flex-end"
					>
                        <Button onClick={() => handleSaveModalClose()} variant="outlined">
                            No
                        </Button>
                        <Button onClick={onSaveClick} variant="contained">
                            Yes
                        </Button>
					</Stack>
				</div>
			</Container>
		</Modal>
    )
}